var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"agro-rating-icon"},[_vm._l((_vm.ticks),function(tick){return _c('li',{staticClass:"agro-rating-icon--item",style:(_vm.getStyle(tick))})}),_c('li',{staticClass:"agro-rating-icon--label"},[_vm._v(_vm._s(_vm.label))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }